// The "these numbers are a projection, not your register" watermark.
//
// It shipped as a byte-identical copy in two components, at opacity-[0.03] on
// `text-warning`. That composites to 1.011:1 against the light card — invisible
// rather than subtle — and no opacity value could have fixed it, because
// `--warning` on white tops out at 1.416:1 at full alpha. The ink was the
// constraint, not the alpha. See --scenario-watermark in index.css.
//
// It lives here rather than being copied so the next change to it happens once.

import { cn } from '@/lib/utils';

interface ScenarioWatermarkProps {
  /** Extra classes, e.g. to shift it off centre in a chart. */
  className?: string;
}

export function ScenarioWatermark({ className }: ScenarioWatermarkProps) {
  return (
    <div
      className={cn(
        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
        'pointer-events-none select-none z-0',
        'rotate-[-15deg] text-6xl font-bold',
        'text-scenario-watermark opacity-[0.22]',
        className
      )}
    >
      SCENARIO
    </div>
  );
}
